import React, { useEffect, useState } from 'react'
import { Button, Card, Col, DatePicker, Input, Modal, Popover, Row, Select } from 'antd'
import { useSelector } from 'react-redux'
import { InfoCircleOutlined, SearchOutlined } from '@ant-design/icons'
import { downLoadFileBlob, formatMessageNew } from '@/utils/common'
import AntdTable from '@/components/table/AntdTable'
import ActionBar from '@/components/table/ActionBar'
import dayjs from 'dayjs'
import { paginationInit } from '../../../utils/common'
import { configQuery } from '../../../services/welcome'
import { suspiciousUidReportDownload, suspiciousUidReportQuery } from '../../../services/configuration/config'

const { RangePicker } = DatePicker
const { Option } = Select

const NFCSuspiciousUidReport = () => {
  const languageState = useSelector(state => state.commonStore.language)
  const [tableList, setTableList] = useState([])
  const [pagination, setPagination] = useState(paginationInit)
  const [filtersState, setFiltersState] = useState({})
  const [plantList, setPlantList] = useState([])
  const [tableKey, setTableKey] = useState(0)
  const [suspiciousType, setSuspiciousType] = useState('SOURCE_MISSING')
  const [plant, setPlant] = useState([])
  const [nfcUid, setNfcUid] = useState('')
  const [operationDate, setOperationDate] = useState([
    dayjs()
      .subtract(7, 'day')
      .startOf('day'),
    dayjs().endOf('day')
  ])

  const getParams = () => {
    const params = {
      suspiciousType: suspiciousType,
      plant: plant || [],
      nfcUid,
      timeStart:
        Array.isArray(operationDate) && operationDate[0]
          ? `${dayjs(operationDate[0]).format('YYYY-MM-DD')} 00:00:00`
          : undefined,
      timeEnd:
        Array.isArray(operationDate) && operationDate[1]
          ? `${dayjs(operationDate[1]).format('YYYY-MM-DD')} 23:59:59`
          : undefined,
      isChinese: languageState === 'zh_CN'
    }
    return params
  }

  const tableColumnsNormal = [
    {
      title: formatMessageNew('languageObj.emailNfcSuspiciousUidReport.nfcUid'),
      dataIndex: 'nfcUid',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailNfcSuspiciousUidReport.plant'),
      dataIndex: 'plantCode',
      width: '100px'
    },
    {
      title: formatMessageNew('languageObj.emailNfcSuspiciousUidReport.operation'),
      dataIndex: 'operation',
      width: '100px',
      filters:
        getParams().suspiciousType !== 'NON_TAGGED'
          ? [
              { text: 'Tagging', value: 'Tagging' },
              { text: 'Disable', value: 'Disable' },
              { text: 'Return Validation', value: 'Return Validation' }
            ]
          : null,
      onFilter: (value, record) => {
        return record.operation === value
      },
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailNfcSuspiciousUidReport.blockReason'),
      dataIndex: 'blockReason',
      width: '100px',
      filters:
        getParams().suspiciousType !== 'NON_TAGGED'
          ? [
              { text: 'UID has been disabled', value: 'UID has been disabled' },
              { text: 'UID does not exist in T-Hub', value: 'UID does not exist in T-Hub' }
            ]
          : [
              { text: 'UID has been disabled', value: 'UID has been disabled' },
              { text: 'UID has no binding record', value: 'UID has no binding record' }
            ],
      onFilter: (value, record) => {
        return record.blockReason === value
      },
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailNfcSuspiciousUidReport.operationDate'),
      dataIndex: 'operationTime',
      width: '100px',
      render: text => {
        return text ? dayjs(parseInt(text)).format('YYYY-MM-DD HH:mm:ss') : ''
      }
    }
  ]
  const tableColumnsDuplicate = [
    {
      title: formatMessageNew('languageObj.emailNfcSuspiciousUidReport.nfcUid'),
      dataIndex: 'nfcUid',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailNfcSuspiciousUidReport.plant'),
      dataIndex: 'plantCode',
      width: '100px'
    },
    {
      title: formatMessageNew('languageObj.emailNfcSuspiciousUidReport.operation'),
      dataIndex: 'operation',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailNfcSuspiciousUidReport.operationDate'),
      dataIndex: 'operationTime',
      width: '100px',
      render: text => {
        return text ? dayjs(parseInt(text)).format('YYYY-MM-DD HH:mm:ss') : ''
      }
    }
  ]

  useEffect(() => {
    searchPlantList()
    // searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const searchPlantList = () => {
    let num = 99999999
    const params = {
      configKey: 'plant_code',
      configStatus: true,
      configType: 'plant_code_config',
      pageNo: 1,
      size: num,
      total: num
    }
    Promise.all([configQuery(params)]).then(res => {
      try {
        let arr = []
        let res0 = res[0].resultData.records
        for (let index = 0; index < res0.length; index++) {
          const element = res0[index]
          arr.push({
            label: element.configValue,
            value: element.configValue
          })
        }
        setPlantList(arr)
      } catch (error) {}
    })
  }

  const searchDataFun = () => {
    const params = {
      ...getParams(),
      size: pagination.pageSize,
      pageNo: pagination.currentPage,
      ...(filtersState || {}) // 确保 filtersState 存在
    }

    const timeStart = dayjs(params.timeStart)
    const timeEnd = dayjs(params.timeEnd)

    if (params.suspiciousType === 'DUPLICATE_RETURN' && timeEnd.diff(timeStart, 'day') > 31) {
      Modal.warning({
        title: 'Warning',
        content: formatMessageNew('languageObj.emailNfcSuspiciousUidReport.warningContent')
      })
      return // 超过31天直接返回
    }

    suspiciousUidReportQuery(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records) // 更新表格数据
      setPagination(prev => ({
        ...prev,
        total: dt.total // 更新总条数
      }))
    })
  }

  const downLoadFun = () => {
    const params = getParams()
    suspiciousUidReportDownload(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  const handleTableChange = (pagination, filters, sorter) => {
    setFiltersState(filters) // 更新 filtersState
    const params = {
      ...getParams(),
      pageNo: pagination.current,
      size: pagination.pageSize,
      ...filters
    }

    suspiciousUidReportQuery(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      setPagination({
        ...pagination,
        total: dt.total
      })
    })
  }

  const onClear = () => {
    setPlant([])
    setNfcUid('')
    setOperationDate([
      dayjs()
        .subtract(7, 'day')
        .startOf('day'),
      dayjs().endOf('day')
    ])
    const params = {
      suspiciousType: suspiciousType,
      plant: [],
      nfcUid: '',
      timeStart: `${dayjs()
        .subtract(7, 'day')
        .startOf('day')
        .format('YYYY-MM-DD')} 00:00:00`,
      timeEnd: `${dayjs()
        .endOf('day')
        .format('YYYY-MM-DD')} 23:59:59`,
      isChinese: languageState === 'zh_CN',
      size: pagination.pageSize,
      pageNo: 1, // 清空后从第一页开始,
      filters: {}
    }
    suspiciousUidReportQuery(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records) // 重置表格数据
      setPagination({
        ...pagination,
        currentPage: 1,
        total: dt.total // 更新总条数
      })
    })
    // 重置 filtersState 并强制刷新表格
    setFiltersState({})
    setTableKey(prevKey => prevKey + 1) // 更新表格 key
  }

  return (
    <div style={{ overflowY: 'hidden' }}>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <Row gutter={16} style={{ marginBottom: '10px' }}>
            <Col span={11}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ width: '30%' }}>
                  {formatMessageNew('languageObj.emailNfcSuspiciousUidReport.suspiciousType')}
                </label>
                <Select
                  value={suspiciousType}
                  onChange={value => {
                    setPlant([])
                    setNfcUid('')
                    setOperationDate([
                      dayjs()
                        .subtract(7, 'day')
                        .startOf('day'),
                      dayjs().endOf('day')
                    ])
                    setFiltersState({}) // 清空其他 filtersState
                    setTableKey(prevKey => prevKey + 1) // 更新表格 key
                    setSuspiciousType(value)
                    setTableList([])
                    setPagination({
                      ...pagination,
                      currentPage: 1,
                      total: 0 // 更新总条数
                    })
                    // // 调用查询接口
                    // const params = {
                    //   suspiciousType: value,
                    //   plant: [],
                    //   nfcUid: '',
                    //   timeStart: `${dayjs()
                    //     .subtract(7, 'day')
                    //     .startOf('day')
                    //     .format('YYYY-MM-DD')} 00:00:00`,
                    //   timeEnd: `${dayjs()
                    //     .endOf('day')
                    //     .format('YYYY-MM-DD')} 23:59:59`,
                    //   isChinese: languageState === 'zh_CN',
                    //   size: pagination.pageSize,
                    //   pageNo: pagination.currentPage
                    // }
                    // suspiciousUidReportQuery(params).then(res => {
                    //   const dt = res.resultData
                    //   setTableList(dt.records)
                    //   setPagination({
                    //     ...pagination,
                    //     total: dt.total
                    //   })
                    // })
                  }}
                  style={{ width: '70%' }}
                >
                  <Option value="SOURCE_MISSING">Source-missing/Disabled UID</Option>
                  <Option value="NON_TAGGED">Non-Tagged/Disabled Return UID</Option>
                  <Option value="DUPLICATE_RETURN">Duplicate Return UID &lt;= 48 Hrs</Option>
                </Select>
                <Popover
                  content={
                    <>
                      {suspiciousType === 'SOURCE_MISSING' && (
                        <div>
                          <span style={{ fontWeight: 700 }}>Source-missing/Disabled UID:</span>
                          <br />
                          &nbsp;&nbsp;&nbsp;UID does not exists in system or was disabled before
                          <br />
                          &nbsp;&nbsp;&nbsp;but have operation records from WMS.
                        </div>
                      )}
                      {suspiciousType === 'NON_TAGGED' && (
                        <div>
                          <span style={{ fontWeight: 700 }}>Non-Tagged/Disabled Return UID:</span>
                          <br />
                          &nbsp;&nbsp;&nbsp;UID do not have tagging history or have been disabled
                          <br />
                          &nbsp;&nbsp;&nbsp;but being validated in WMS.
                        </div>
                      )}
                      {suspiciousType === 'DUPLICATE_RETURN' && (
                        <div>
                          <span style={{ fontWeight: 700 }}>
                            Duplicate Return UID &lt;=48 Hrs: <br />
                          </span>
                          &nbsp;&nbsp;&nbsp;Multiple return records (&lt;= 5 times) for same UID
                          <br />
                          &nbsp;&nbsp;&nbsp;within past 48 hours.
                        </div>
                      )}
                    </>
                  }
                  trigger="click"
                  placement="bottomRight"
                >
                  <InfoCircleOutlined
                    style={{
                      marginLeft: 8,
                      color: 'black',
                      cursor: 'pointer',
                      display: 'inline-block',
                      verticalAlign: 'middle'
                    }}
                  />
                </Popover>
              </div>
            </Col>
            <Col span={2}></Col>
            <Col span={11}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ width: '30%' }}>
                  {formatMessageNew('languageObj.emailNfcSuspiciousUidReport.plant')}
                </label>
                <Select mode="multiple" value={plant} onChange={setPlant} style={{ width: '70%' }} allowClear>
                  {plantList.map(item => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </div>
            </Col>
          </Row>
          <Row gutter={16} style={{ marginBottom: '3px' }}>
            <Col span={11}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ width: '29%' }}>
                  {formatMessageNew('languageObj.emailNfcSuspiciousUidReport.nfcUid')}
                </label>
                <Input
                  value={nfcUid}
                  onChange={e => setNfcUid(e.target.value)}
                  placeholder={formatMessageNew('languageObj.emailNfcSuspiciousUidReport.printNfcId')}
                  allowClear
                  style={{ width: '67.5%' }}
                />
              </div>
            </Col>
            <Col span={2}></Col>
            <Col span={11}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ width: '30%' }}>
                  {formatMessageNew('languageObj.emailNfcSuspiciousUidReport.operationDate')}
                </label>
                <RangePicker
                  value={operationDate}
                  onChange={setOperationDate}
                  style={{ width: '70%' }}
                  allowClear={false}
                  disabledDate={current => {
                    if (suspiciousType === 'DUPLICATE_RETURN') {
                      return current && current.isAfter(dayjs().endOf('day')) // 禁用当前日期之后的时间
                    } else {
                      return current && current.isAfter(dayjs().endOf('day'))
                    }
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row justify="end" gutter={16} style={{ marginTop: 16 }}>
            <Col>
              <Button type="primary" icon={<SearchOutlined />} onClick={searchDataFun}>
                {formatMessageNew('languageObj.commonLocale.search')}
              </Button>
            </Col>
            <Col>
              <Button onClick={onClear}>{formatMessageNew('languageObj.commonLocale.clear')}</Button>
            </Col>
          </Row>
        </div>
        <div className="content-container">
          <ActionBar onDownload={downLoadFun} style={{ alignItems: 'end' }}></ActionBar>
          <AntdTable
            key={tableKey}
            dataSource={tableList}
            columns={getParams().suspiciousType === 'DUPLICATE_RETURN' ? tableColumnsDuplicate : tableColumnsNormal}
            // 独一无二的表示，不能重复
            columnsKey="nfcSuspiciousUidReportColumns"
            pagination={pagination}
            onChange={handleTableChange}
            filters={filtersState} // 绑定 filtersState
          />
        </div>
      </Card>
    </div>
  )
}
export default NFCSuspiciousUidReport
